@let holdingData = holding();

<div class="td-wb-fpl-on-loan">
   <a role="button"
      tabindex="0"
      href=""
      translate="tdWb.fpl.onLoan.ON_LOAN"
      [tdWbOverlayToggle]="onLoanTemplate"
      tdWbOverlaySize="small"
      tdWbOverlayPosition="center-right"
      [tdWbOverlayData]="holdingData"
      [tdWbOverlayAsync]="true"
      (tdWbOverlayAsyncOpen)="asyncOpen($event)"
      (click)="openOnLoanOverlay()"
      (keydown.enter)="openOnLoanOverlay()"
      (onClose)="closeOnLoanOverlay()"
      class="td-wb-fpl-on-loan__link">
   </a>
</div>
<ng-template #onLoanTemplate>
  <td-wb-overlay aria-labelledby="td-wb-on-loan-overlay-title"
                 class="td-wb-on-loan-overlay"
                 #overlay="tdWbOverlay">
    <td-wb-overlay-header id="td-wb-on-loan-overlay-title"
                          translate="tdWb.fpl.onLoan.TITLE" />
    @if (showDividendNotification) {
      <td-wb-notification notificationType="info"
                          class="td-wb-on-loan-overlay__dividend-notification">
        <span translate="tdWb.fpl.onLoan.DIVIDEND_NOTICE"></span>
        <a tdWbHelpLink="acct_stock_lending"
           class="td-wb-on-loan-overlay__dividend-notice-link">
          <span translate="tdWb.fpl.onLoan.LEARN_MORE"></span>
        </a>
      </td-wb-notification>
    }
    <td-wb-ticker-symbol-table-container class="td-wb-on-loan-overlay-symbol__container">
      @if (showLogo) {
        <td-wb-symbol-logo [svgString]="holdingData.logoLight"
                           [symbol]="holdingData.symbol?.tickerSymbol"
                           [market]="holdingData.symbol?.market"
                           [description]="holdingData.name" />
      }
      <td-wb-ticker-symbol [market]="holdingData.symbol?.market"
                           [tickerSymbol]="holdingData.symbol?.tickerSymbol"
                           [description]="holdingData.name" />
    </td-wb-ticker-symbol-table-container>
    <td-wb-list listSize="compact"
                [embedded]="true">
      @if (isRecallActionPending()) {
        <td-wb-list-item>
          <td-wb-list-item-label translate="tdWb.fpl.onLoan.PENDING_ACTION" />
          <td-wb-list-item-value translate="tdWb.fpl.onLoan.RECALL_ACTION" />
        </td-wb-list-item>
      }
      <td-wb-list-item>
        <td-wb-list-item-label translate="tdWb.fpl.onLoan.SHARES_ON_LOAN" />
        <td-wb-list-item-value [innerText]="loanQuantityDisplayValue()" />
      </td-wb-list-item>
      <td-wb-list-item>
        <td-wb-list-item-label translate="tdWb.fpl.onLoan.LOAN_VALUE" />
        <td-wb-list-item-value [innerText]="holdingData.onLoanMarketValue | tdWbCurrency : { format: 'c4-2', emptyPlaceholder : '-' }" />
      </td-wb-list-item>
      <td-wb-list-item>
        <td-wb-list-item-label translate="tdWb.fpl.onLoan.INITIAL_INTEREST_RATE" />
        <td-wb-list-item-value [innerText]="initialInterestRateDisplayValue()" />
      </td-wb-list-item>
      <td-wb-list-item>
        <td-wb-list-item-label translate="tdWb.fpl.onLoan.CURRENT_INTEREST_RATE" />
        <td-wb-list-item-value [innerText]="currentInterestRateDisplayValue()" />
      </td-wb-list-item>
    </td-wb-list>
    <div class="td-wb-on-loan-overlay__actions">
      @if (!isRecallActionPending()) {
        <button id="td-wb-on-loan-overlay-recall"
                class="td-wb-on-loan-overlay__actions-button"
                type="button"
                tdWbButton
                tdWbButtonType="secondary"
                (click)="openFplRecallSecurityModal()">
          <span translate="tdWb.fpl.onLoan.RECALL_BUTTON"></span>
        </button>
      }
      <button id="td-wb-on-loan-overlay-details"
              class="td-wb-on-loan-overlay__actions-button"
              type="button"
              tdWbButton
              tdWbButtonType="primary"
              tdWbHref="page.account.stock-lending"
              [tdWbHrefParams]="{ tab: 'onLoan' }"
              tdWbHrefTaggingEvent="stocklending:details">
        <span translate="tdWb.fpl.onLoan.DETAILS_BUTTON"></span>
      </button>
    </div>
  </td-wb-overlay>
</ng-template>
<ng-template #fplRecallSecurityModalTemplate>
  <td-wb-fpl-recall-security [holding]="holdingData"
                             [numberOfShares]="holdingData.onLoanQuantity"
                             [accountId]="accountId()"
                             (recallSucessful)="closeFplRecallSecurityModal()" />
</ng-template>
